"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupersetDashboard = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const embedded_sdk_1 = require("@superset-ui/embedded-sdk");
const template = `<div class="vue-superset-dashboard">
  <div ref="target" :style="{width, height}"></div>
</div>`;
let SupersetDashboard = class SupersetDashboard extends vue_property_decorator_1.Vue {
    $refs;
    timer;
    width;
    height;
    dashboardId;
    accessData;
    filtersExpanded;
    filtersVisible;
    hideChartControls;
    data() {
        return {
            width: '100%',
            height: '100%',
            timer: null
        };
    }
    mounted() {
        this.initialize().catch(error => this.$emit('error', { error }));
    }
    async fetchAccessData() {
        return await this.accessData(this.dashboardId);
    }
    onDashboardCreated(db) {
    }
    beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    async initialize() {
        const accessData = await this.fetchAccessData();
        console.log('Access Data', accessData);
        const dashboard = await (0, embedded_sdk_1.embedDashboard)({
            id: this.dashboardId,
            supersetDomain: accessData.domain,
            mountPoint: this.$refs.target,
            fetchGuestToken: async () => accessData.guestToken,
            dashboardUiConfig: {
                hideTitle: true,
                hideChartControls: this.hideChartControls,
                filters: {
                    expanded: this.filtersExpanded,
                    visible: this.filtersVisible
                }
            }
        });
        this.onDashboardCreated(dashboard);
        return dashboard;
    }
};
exports.SupersetDashboard = SupersetDashboard;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], SupersetDashboard.prototype, "dashboardId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Function)
], SupersetDashboard.prototype, "accessData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
    __metadata("design:type", Boolean)
], SupersetDashboard.prototype, "filtersExpanded", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
    __metadata("design:type", Boolean)
], SupersetDashboard.prototype, "filtersVisible", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true }),
    __metadata("design:type", Boolean)
], SupersetDashboard.prototype, "hideChartControls", void 0);
exports.SupersetDashboard = SupersetDashboard = __decorate([
    (0, vue_property_decorator_1.Component)({ template })
], SupersetDashboard);
//# sourceMappingURL=superset-dashboard.js.map